import React from 'react';
import PropTypes from 'prop-types';

import './QuoteCard.scss';

import ResponsivePicture from '../../../Elements/ResponsivePicture/ResponsivePicture';
import Logo from '../../../Elements/Logo/Logo';

export default class QuoteCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.baseClassName = 'component-Employer-Marketing-QuoteCard';
    }

    static propTypes = {
        header: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }).isRequired,
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }).isRequired,
        quote: PropTypes.string.isRequired,
        author: PropTypes.string.isRequired,
    };

    renderCompanyHeader = () => {
        return (
            <div className="images-container">
                <ResponsivePicture
                    cloudinaryID={this.props.header.src}
                    alt={this.props.header.alt}
                    className="company-header-image"
                />
                <Logo
                    cloudinaryID={this.props.logo.src}
                    alt={this.props.logo.alt}
                />
            </div>
        );
    };

    renderQuoteContainer = () => {
        return (
            <div className="quote-container">
                <p className="quote">{this.props.quote}</p>
                <p className="author">{this.props.author}</p>
            </div>
        );
    };

    render() {
        return (
            <div className={this.baseClassName}>
                {this.renderCompanyHeader()}
                {this.renderQuoteContainer()}
            </div>
        );
    }
}
